import assert from 'assert';
import {Message, WizLogDetail} from '../../interface';
import {fixRepositoryName} from '@/domains/space/Repository/Utils/fixRepositoryNameWithPersonal';
import {get} from 'lodash-es';
import {ENVIRONMENT_LEVEL} from '@/Constant';
import {ServerConfig} from '@/config/routers';
import {serverBaseObj} from './server_base';
import * as store from '@/store';


export function toMessage(item: { [key: string]: any }): Message {
    assert(item);
    assert(item.json);
    try {
        item.json = JSON.parse(item.json);
        item.eventData = item.eventData.trim() && JSON.parse(item.eventData);
    } catch (error) {
        console.error(error);
    }
    assert(item.json.data);
    assert(item.json.data.data);
    const message: Message = {
        id: item.id as number,
        messageGuid: item.messageGuid as string,
        repositoryGuid: item.repositoryGuid,
        action: item.action || item.json.data.action as number,
        type: item.json.data.type as number,
        timestamp: item.json.data.timestamp as number,
        sender: item.json.sender as { userGuid: string, nickname: string },
        receiver: item.json.receiver as { userGuid: string, nickname: string },
        event: item.eventData ? item.eventData.event : null,
        data: item.json.data as WizLogDetail,
        status: item.status,
        source: get(item, 'json.data.data.meta.source', ''),
    };
    if (message.data.data && message.data.data.repository) {
        const r: Repository = message.data.data.repository;
        fixRepositoryName(r);
    }
    return message;
}

export function getMessagesObject(result: [{ [key: string]: any }]): Message[] {
    assert(result);
    const messages: Message[] = result.map((item: { [index: string]: any }) => {
        return toMessage(item);
    });
    return messages;
}


export function getDocUrl({
    spaceGuid,
    groupGuid,
    repositoryGuid,
    docGuid,
}: {
    spaceGuid: string;
    groupGuid: string;
    repositoryGuid: string;
    docGuid: string;
}) {
    let origin = window.location.origin;
    if (process.env.REACT_APP_ENVIRONMENT === ENVIRONMENT_LEVEL.local) {
        origin = 'http://ku.dev.weiyun.baidu.com';
    }
    return `${origin}/knowledge/${spaceGuid}/${groupGuid}/${repositoryGuid}/${docGuid}`;
}

export const getDstToken = async () => {
    const origin = ServerConfig.origin;

    try {
        // @dst-todo 缓存逻辑暂时注释，后续再做优化
        // const dataSheetToken = storageUtils.get(DataSheetTokenStorageKey);
        // if (dataSheetToken) {
        //     store.setDstToken(dataSheetToken);
        //     return dataSheetToken;
        // }

        const result = await serverBaseObj.request({
            method: 'get',
            // eslint-disable-next-line max-len
            url: `${origin}/api/v1/social/oneaccess/login?reference=${origin}/api/v1/user/me`,
            noFrontTrace: true,
        });

        const token = result?.apiKey || '';
        // @dst-todo 缓存逻辑暂时注释，后续再做优化
        // storageUtils.set(DataSheetTokenStorageKey, token);
        store.setDstToken(token);

        return token;
    } catch (err) {
        console.error(err);
        throw Error('getDstToken Error');
    }
};

export async function complainSubmit(data: any) {
    const url = process.env.REACT_APP_DOC_COMPLAIN_DATASHEET ||
        'https://ku.baidu-int.com/fusion/v1/datasheets/dstiYByU19h9RJp0Ji/records?viewId=viw6o8jFuKQ4a';
    const proxyOrigin = process.env.REACT_APP_KU_PROXY_SERVER || 'https://ku-proxy.now.baidu-int.com';
    const proxyUrl = `${proxyOrigin}/api/datasheet/proxy?url=${encodeURIComponent(url)}`;
    const result = await serverBaseObj.request({
        method: 'post',
        url: proxyUrl,
        data,
    });
    return result;
}
